import { getQueryStringValue } from 'utilities/browser';
import { addClassDuringActivity } from 'utilities/dom';
import { Reporter } from 'features/dataCapture';

import dynamicImport from '../../../_client/features/webpack/dynamicImport.macro';

qtee.customDesign = window.qtee.customDesign || {};
const { shippingTerms } = window.lp.getPageData();

/** Main Item */
qtee.customDesign.MainView = Backbone.Marionette.LayoutView.extend({
	template: '/custom-design/templates/main',
	regions: {
		colorTextRegion: '#colorTextElement',
		newTextElementRegion: '#newTextElement',
		newDesignElementRegion: '#newDesignElement',
		newBackgroundElementRegion: '#newBackgroundElement',
		newImageElementRegion: '#newImageElement',
		editTextElementRegion: '#editTextElement',
		otherStylesRegion: '#otherStyles',
		fontTextElementRegion: '#fontTextElement',
		sizeTextElementRegion: '#sizeTextElement',
		addToCartModalRegion: '#addToCartModal',
		previewModalRegion: '#previewModal',
		prodDetailsTop: '#prodDetailsTop',
		prodDetailsBottom: '#prodDetailsBottom'
	},
	ui: {
		messageAlert: '.messageAlert',
		canvas: '#customDesignCanvas',
		commonControls: '.commonControl',
		centerBtn: '.centerEl',
		straightBtn: '.straightEl',
		fillBtn: '.fillEl',
		duplicateBtn: '.duplicate',
		forwardBtn: '.forward',
		backBtn: '.backward',
		resetBtn: '.reset',
		deleteBtn: '.delete',
		undoBtn: '.undo',
		shareBtn: '.share',
		restartBtn: '.restart',
		deleteScene: '.deleteScene',
		share: '.share',
		print: '.print',
		help: '.help',
		helpers: '#helpers .item',
		shareTooltip: '#shareTooltip',
		doneBtn: '.done',

		// social buttons
		socialButtons: '.socialButtons',
		email: '.socialButtons .jsEmail',
		facebook: '.socialButtons .jsFacebook',
		pinterest: '.socialButtons .jsPinterest',
		google: '.socialButtons .jsGoogle',
		houzz: '.socialButtons .jsHouzz',

		// navbar to add a new element
		newImageAdd: '#newElementNav .newImageElement',
		newGraphicsAdd: '#newElementNav .newGraphicsElement',
		newBackgroundAdd: '#newElementNav .newBackgroundElement',
		newTextElementAdd: '#newElementNav .newTextElement',

		// sections
		otherStylesSection: '#otherStyles',
		newTextElementSection: '#newTextElement',
		editTextElementSection: '#editTextElement',
		colorTextElementSection: '#colorTextElement',
		fontTextElementSection: '#fontTextElement',
		sizeTextSection: '#sizeTextElement',
		newDesignSection: '#newDesignElement',
		imageSection: '#editImageElement',
		newImageSection: '#newImageElement',
		editDesignSection: '#editDesignElement',
		backgroundSection: '#newBackgroundElement',
		editBackgroundSection: '#editBackgroundElement',

		// done buttons in sections
		newDesignDone: '#newDesignElement .back',
		editDesignDone: '#editDesignElement .back',
		newBackgroundDone: '#newBackgroundElement .back',
		editBackgroundDone: '#editBackgroundElement .back',
		imageDone: '#editImageElement .back',
		textDone: '#editTextElement .back',

		// save to favorites
		saveBtn: '.prodSave',

		// controls for text element
		// text edit section
		textSection: '#textElement',
		textEdit: '#editTextBtn',
		textFont: '#textElement .textFontBtn',
		textColor: '#colorTextBtn',

		// restart / undo group
		restartUndoGroup: '.restartUndoGroup',

		// preview design
		preview: '.previewDesign',

		// add to cart button
		qtyInput: '.pdQtyInput',
		addToCartBtn: '.atcBtn',
		addToWishList: '.addToWishList',
		emptySceneMessage: '.emptySceneMessage',
		closeToolTip: '.closeToolTip',
		startCreating: '.startCreating',

		updateProduct: '.updateProduct',
		cancelUpdate: '.cancelUpdate',

		// scene REST api
		sceneGet: '#sceneGet.active',
		sceneCreate: '#sceneCreate.active',
		sceneUpdate: '#sceneUpdate.active',
		sceneId: '#sceneId',

		// product change functionality
		prodSku: '#prodSku',
		prodSkuChange: '#prodSkuChange',

		// status
		status: '#status',

		limitReachedModal: '#limitReachedModal',

		loadingOverlay: '.loadingOverlay2',

		// open shipping information
		openShipInfo: '#pdInStock'
	},

	events: {
		'click @ui.centerBtn:not(.disabled)': 'centerClick',
		'click @ui.straightBtn:not(.disabled)': 'straightClick',
		'click @ui.fillBtn:not(.disabled)': 'fillClick',
		'click @ui.duplicateBtn:not(.disabled)': 'duplicateClick',
		'click @ui.forwardBtn:not(.disabled)': 'forwardClick',
		'click @ui.backBtn:not(.disabled)': 'backClick',
		'click @ui.deleteBtn:not(.disabled)': 'deleteClick',
		'click @ui.undoBtn:not(.disabled)': 'undoClick',
		'click @ui.restartBtn:not(.disabled)': 'restartClick',
		'click @ui.deleteScene:not(.disabled)': 'deleteScene',
		'click @ui.pinterest': 'pinterestClick',
		'click @ui.facebook': 'facebookClick',
		'click @ui.google': 'googleClick',
		'click @ui.houzz': 'houzzClick',
		'click @ui.email': 'emailClick',
		'click @ui.print:not(.disabled)': 'print',

		// add new element
		'click @ui.newTextElementAdd': 'newTextElementClick',
		'click @ui.newImageAdd:not(.disabled)': 'addImageClick',
		'click @ui.newGraphicsAdd:not(.disabled)': 'addNewDesignClick',
		'click @ui.newBackgroundAdd:not(.disabled)': 'addNewBackgroundClick',
		'keypress @ui.newGraphicsAdd:not(.disabled)': 'addNewDesignEnter',
		'keypress @ui.newTextElementAdd': 'newTextElementEnter',
		'keypress @ui.newImageAdd:not(.disabled)': 'addImageEnter',
		'keypress @ui.newBackgroundAdd:not(.disabled)': 'addNewBackgroundEnter',

		// sections button done button click events
		'click @ui.imageDone': 'sectionDoneClick',
		'click @ui.newDesignDone': 'sectionDoneClick',
		'click @ui.editDesignDone': 'sectionDoneClick',
		'click @ui.newBackgroundDone': 'sectionDoneClick',
		'click @ui.editBackgroundDone': 'sectionDoneClick',
		'click @ui.textDone': 'sectionDoneClick',
		'keypress @ui.doneBtn': 'textDoneKeyPress',

		// save to favorites
		'click @ui.saveBtn.on': 'saveToFavorites',

		// text element controls
		'click @ui.textEdit:not(.disabled)': 'textEditClick',
		'click @ui.textFont:not(.disabled)': 'textFontClick',
		'click @ui.textColor:not(.disabled)': 'textColorClick',

		// preview designs
		'click @ui.preview:not(.disabled)': 'previewClick',

		// add to cart and wishlist
		'click @ui.addToCartBtn:not(.disabled)': 'addToCartClick',
		'click @ui.addToWishList:not(.disabled)': 'addToWishListClick',
		'click @ui.closeToolTip': 'closeEmptySceneMessageClick',
		'click @ui.startCreating': 'closeEmptySceneMessageClick',

		// cancel/update for no-autosave
		'click @ui.cancelUpdate:not(.disabled)': 'cancelUpdateClick',
		'click @ui.updateProduct:not(.disabled)': 'updateProductClick',

		// scene REST api
		'click @ui.sceneGet': 'sceneGetClick',
		'click @ui.sceneCreate': 'sceneCreateClick',
		'click @ui.sceneUpdate': 'sceneUpdateClick',

		// product info
		'click @ui.prodSkuChange': 'prodSkuChangeClick',

		// normalize qty
		'blur @ui.qtyInput': 'normalizeQty',
		'keypress @ui.qtyInput': 'normalizeQtyInput',

		// open shipping information
		'click @ui.openShipInfo': 'openShippingModal'
	},
	modelEvents: {
		change: 'bindCollections'
	},
	initialize(opts) {

		const that = this;

		if (!this.model.operationResult.IsSuccessful) {

			this.operationError(this.model);

		}

		this.$events = $(qtee.customDesign);

		if (opts.noAutoSave) {

			Backbone.customDesign.startEmulateAjax();
			this.initModel = this.model.clone();

		}

		this.otherProductsModel = new qtee.customDesign.CustomUploadProducts();
		this.otherProductsModel.fetch();

		this.prodModel = new qtee.shared.ProdModel({ ShortSku: this.model.get('ShortSku') });
		this.prodModel.fetch({
			success() {
				const customDesignCanvas = document.getElementById('customDesignCanvas');
				if (customDesignCanvas) {
					customDesignCanvas.setAttribute('data-sku-input-type', that.prodModel.get('SkuInputType'))
				}
			}
		});

		this.previewModel = new qtee.customDesign.Preview({ Token: this.model.get('Token') });

		this.bindCollections();
		this.listenTo(this.model, 'change:ShortSku', function () {

			// loader
			const stopLoader = this.$events.triggerHandler('startLoader');

			that.prodModel.set({ ShortSku: that.model.get('ShortSku') }).fetch({
				success(r) {

					that.rerenderDetails();

				},
				error(r) {

					that.operationError(r);

				},
				complete() {

					stopLoader();

				}
			});

		});

		qtee.customDesign.prevBg = [];

		// fetch available colors
		qtee.customDesign.availableColors.fetch();

		// fetch available patterns
		qtee.customDesign.availablePatterns.fetch({
			data: { token: this.model.get('Token') },
			success(model) {

				let isBackground = false;
				const patternId = getQueryStringValue('pattern');
				const addCurrentBg = function (model) {

					if (model && model.attributes) {

						delete model.attributes.Token;
						model.attributes.ZOrder = 0;

						qtee.customDesign.currentBg = {
							operation: 'create',
							type: 'pattern',
							isBackground: true,
							sid: model.id,
							json: model.attributes
						};

					}

				};
				const result = _.find(model.get('backgrounds'), (item) => {

					if (item.PatternId == patternId) {

						isBackground = true;

					}
					return item.PatternId == patternId;

				})
					|| _.find(model.get('patterns'), (item) => {

						if (item.PatternId == patternId) {

							isBackground = false;

						}
						return item.PatternId == patternId;

					});
				const search = window.location.search.indexOf('?sku=') == 0 ? window.location.search.split('&pattern')[0] : '';

				if (result && result.PatternId) {

					var this_model = that.model.elements.pattern.create(
						{
							OriginX: that.model.area.Width / 2,
							OriginY: that.model.area.Height / 2,
							IsBackground: isBackground,
							PatternId: result.PatternId,
							Scale: that.model.isPillow()
								? isBackground
									? qtee.customDesign.settings.newEl.background.scale
									: qtee.customDesign.settings.newEl.design.scale
								: isBackground
									? qtee.customDesign.settings.newEl.backgroundLampshade.scale
									: qtee.customDesign.settings.newEl.designLampshade.scale,
							Width: that.model.isPillow()
								? isBackground
									? qtee.customDesign.settings.newEl.background.width
									: qtee.customDesign.settings.newEl.design.width
								: isBackground
									? qtee.customDesign.settings.newEl.backgroundLampshade.width
									: qtee.customDesign.settings.newEl.designLampshade.width,
							Height: that.model.isPillow()
								? isBackground
									? qtee.customDesign.settings.newEl.background.height
									: qtee.customDesign.settings.newEl.design.height
								: isBackground
									? qtee.customDesign.settings.newEl.backgroundLampshade.height
									: qtee.customDesign.settings.newEl.designLampshade.height,
							RotationalDegree: that.model.isPillow()
								? isBackground
									? qtee.customDesign.settings.newEl.background.rotation
									: qtee.customDesign.settings.newEl.design.rotation
								: isBackground
									? qtee.customDesign.settings.newEl.backgroundLampshade.rotation
									: qtee.customDesign.settings.newEl.designLampshade.rotation,
							PatternImageUrl: result.PatternImageUrl,
							ZOrder: isBackground ? 0 : qtee.customDesign.canvas.getMaxZIndex() + 1
						},
						{
							wait: false,
							success(r) {

								const bg_model = _.find(
									that.model.elements.pattern.models,
									(item) => item.attributes.IsBackground == true
								);

								addCurrentBg(bg_model);

								qtee.customDesign.canvas.add(this_model, false, isBackground).then(
									(el) => {

										that.canvasEl = el;
										that.$events.triggerHandler(
											'showSuccessState',
											'canvas element pattern was added'
										);
										window.history.replaceState(
											{},
											document.title,
											window.location.pathname + search + window.location.hash
										);
										setTimeout(() => {
											that.bindDataCapture();
										}, 2000);

									},
									(reason) => {

										that.$events.triggerHandler('showErrorState', reason);
										this_model.destroy();

									}
								);

							},
							error(r) { }
						}
					);

				} else if (!that.model.isEmpty()) {

					const bg_model = _.find(
						that.model.elements.pattern.models,
						(item) => item.attributes.IsBackground == true
					);

					addCurrentBg(bg_model);

					window.history.replaceState(
						{},
						document.title,
						window.location.pathname + search + window.location.hash
					);
					setTimeout(() => {
						that.bindDataCapture();
					}, 2000);

				}

			}
		});

		$(window).on('mousedown', (e_one) => {

			$(window).one('mouseup', (e_two) => {

				if (
					!(
						$(e_one.target).is('svg')
						|| $(e_one.target).parents().is('svg')
						|| $(e_one.target).is('.ignoreClick')
						|| $(e_one.target).parents().is('.ignoreClick')
					)
				) {

					qtee.customDesign.canvas.selectElement(-1);

				}

			});

		});

		// lets start to listen events
		this.$events
			.on('startLoader', (e, delay) => {

				const { loaderThreshold } = qtee.customDesign.settings;
				const delayNum = delay && delay > 0 ? delay : loaderThreshold || 0;

				return window.lp.utils.customDesign.delayLoading(that.ui.loadingOverlay, delayNum);

			})
			.on('showProgressState', () => {

				that.statusProgress();

			})
			.on('showErrorState', (e, r) => {

				that.operationError(r);

			})
			.on('showSuccessState', (e, r) => {

				that.operationSuccess(r);

			})
			.on('showDefaultSection', () => {

				that.showTabSection(false);

			})
			.on('showImageSection', () => {

				that.showTabSection(that.ui.textSection);

			})
			.on('showTextSection', () => {

				that.showTabSection(that.ui.textSection);

			})
			.on('showNewTextSection', () => {

				that.showTabSection(that.regions.newTextElementRegion);

			})
			.on('showEditTextSection', () => {

				that.showTabSection(that.regions.editTextElementRegion);

			})
			.on('showFontTextView', (e, opts) => {

				that.showTabSection(that.regions.fontTextElementRegion);
				that.showChildView(
					'fontTextElementRegion',
					new qtee.customDesign.FontTextView({
						model: opts.model,
						backCallback: opts.backCallback
					})
				);

			})
			.on('showSizeTextView', (e, opts) => {

				that.showTabSection(that.regions.sizeTextElementRegion);
				that.showChildView(
					'sizeTextElementRegion',
					new qtee.customDesign.SizeTextView({
						model: opts.model,
						backCallback: opts.backCallback
					})
				);

			})
			.on('add.history', (e, arr) => {

				that.addToHistory(arr);

			})
			.on('restore.history', () => {

				that.undoHistory();

			})
			.on('adding.elements.canvas', (e, model) => {

				that.statusProgress();

			})
			.on('addSuccess.elements.canvas', (e, element) => {

				that.renderSuccess();

			})
			.on('addFail.elements.canvas', (e, reason) => {

				that.renderError(reason);

			})
			.on('addImageToCanvas', (e, opts) => {

				that.newImageElement(opts);

			})
			// Z-order of element has been changed
			.on('orderChanged.elements.canvas', (e, opts) => {

				const res1 = that.updateElement(opts.el.element);
				const res2 = that.updateElement(opts.exEl.element);

				// when both elements is saved then add them to history
				$.when(res1.xhr, res2.xhr).then(() => {

					that.addToHistory([res2.model, res1.model]);

				});

				that.updateElementsControls(opts.el.element);

			})
			// Element has been deselected
			.on('deselected.elements.canvas', (e, el) => {

				// close tab's section
				that.showTabSection(false);
				// clear all menus first
				that.disableAllSections();
				// reshow restart / undo
				that.showRestartUndoGroup(true);
				that.updateElementsControls();

			})
			// Element has been selected
			.on('selected.elements.canvas', (e, el) => {

				// update common controls
				that.updateElementsControls(el.element);

				// update element controls
				if (el) {

					switch (el.element.type) {

						case 'text': {

							// reshow restart / undo
							that.showRestartUndoGroup(false);
							// show section with text's controls
							that.textEditClick();
							break;

						}
						case 'uploadedimage': {

							// reshow restart / undo
							that.showRestartUndoGroup(false);
							// show section with image controls
							that.showTabSection(that.ui.imageSection);
							break;

						}
						case 'pattern': {

							// reshow restart / undo
							that.showRestartUndoGroup(false);
							// show section with 'design' controls
							that.showTabSection(that.ui.editDesignSection);
							break;

						}
						default: {

							throw 'Incorrect type element';

						}

					}

				}

			})
			// Element has been transformed (moved, scaled, color/font/style has been changed)
			.on('transformed.elements.canvas', (e, element) => {

				if (!element) {

					throw 'No element!';

				}
				const res = that.updateElement(element);
				if (res) {

					// when element is saved then add it to history
					$.when(res.xhr).then(() => {

						that.addToHistory([res.model]);

					});

				}

			})
			.on('cloneSuccess', (e, id) => {

				qtee.customDesign.router.navigate(`load/${id}`, { trigger: true, replace: true });
				qtee.customDesign.sceneCloned = true;
				that.renderScene();

			})
			.on('customDesignChangeMade', (e) => {

				$('.customDesignModal').removeClass('saved');
				$(that.ui.saveBtn).removeClass('disabled').addClass('on');

			})
			.on('changeSku', (e, opts) => {

				that.changeSku(opts.sku);

			})
			.on('deleteElement', (e, el) => {

				that.deleteElement(el);

			})
			.on('cloneText', (e, opts) => {

				that.newTextElementClick(opts);

			});

	},
	bindDataCapture() {

		// only fire sku view event if model is not empty
		if (!this.model.isEmpty()) {

			const canvas = this.ui.canvas[0];
			const { reporter, pageLevelData } = window.lp.dataCapture;
			pageLevelData.url = window.location.href;
			const data = Reporter.getSkuViewData(canvas);
			reporter.track(data, { immediate: true });

		}

	},
	onDestroy() {

		$(qtee.customDesign).off();

	},

	bindCollections() {

		const that = this;
		for (const collection in this.model.elements) {

			this.listenTo(this.model.elements[collection], 'update', () => {

				that.updateCommonUI();

			});
			this.listenTo(this.model.elements[collection], 'error', (r) => {

				that.operationError(r);

			});
			this.listenTo(this.model.elements[collection], 'sync', (r) => {

				that.operationSuccess(`${r.type} was ${r.lastOperation}d`);

			});
			this.listenTo(this.model.elements[collection], 'request', (r) => {

				that.statusProgress();

			});

		}

	},

	rerenderDetails() {

		this.showChildView(
			'prodDetailsTop',
			new qtee.customDesign.DetailsView({ model: this.prodModel, showTop: true, isEmpty: this.model.isEmpty() })
		);
		this.showChildView(
			'prodDetailsBottom',
			new qtee.customDesign.DetailsView({ model: this.prodModel, showTop: false, isEmpty: this.model.isEmpty() })
		);

		return this;

	},
	reRenderOtherStyles() {

		this.showChildView(
			'otherStylesRegion',
			new qtee.customDesign.CategoriesView({ model: this.otherProductsModel })
		);
		return this;

	},

	onRender() {

		this.model.isPillow() && this.ui.preview.parent().removeClass('hidden');

		this.rerenderDetails().reRenderOtherStyles().updateCommonUI();

	},

	/**
	 * Render svg-scene
	 * @param {Boolean} [keepHistory=true]
	 * @return {Promise} always resolved promise since we catch all rejection here
	 */
	renderScene(keepHistory = true) {

		const that = this;

		this.statusProgress();
		return qtee.customDesign.canvas.renderScene(this.model, true).then(
			() => {

				that.renderSuccess();

				if (!that.model.isPillow()) {

					// then product is a lampshade, change canvas settings
					$(that.ui.canvas).css({
						backgroundImage: 'none',
						backgroundColor: '#fff'
					});

				}

			},
			(reason) => {

				that.renderError(reason);

				if (!that.model.isPillow()) {

					// then product is a lampshade, change canvas settings
					$(that.ui.canvas).css({
						backgroundImage: 'none',
						backgroundColor: '#fff'
					});

				}

			}
		);

	},

	onAttach() {

		this.showRestartUndoGroup(true);
		this.renderScene();

		if (!this.model.isPillow()) {

			// then product is a lampshade, change canvas settings
			$(this.ui.canvas).addClass('customLampShade').css({
				backgroundImage: 'none',
				backgroundColor: '#fff'
			});

		}

		// show image tooltip if coming from background template page, or when there are no elements in the scene, and scene has not been restarted
		if (
			document.referrer.indexOf('customphoto/shade-template') > -1
			|| (!this.model.isEmpty()
				&& this.model.elements.image.length == 0
				&& this.model.elements.pattern.length == 0
				&& this.model.elements.text.length == 0)
		) {

			$('#startImageTooltip').removeClass('hidden');
			$('body').on('click', (e) => {

				if (e.target.id !== 'startImageTooltip') {

					$('#startImageTooltip').hide();

				}

			});

		}

	},

	onDomRefresh() {

		this.renderScene();

	},

	templateHelpers() {

		const that = this;
		const isPillow = !!this.model.isPillow();
		const isEmpty = this.model.isEmpty();
		const sku = this.model.get('ShortSku');
		const defaultTrim = isPillow ? 'f5f5f5' : '222222';
		const customizedProductId = this.model.get('CustomizedProductId');
		const customizedProductCombination = `${customizedProductId}~${defaultTrim}`;

		return {
			sku,
			customizedProductCombination,
			isPillow,
			isEmpty,
			showBuyNow() {

				return !that.options.noAutoSave || that.options.isFavorite;

			},
			productName() {

				// may need to modify this if more products are added
				return that.model.isPillow() ? 'pillow' : 'lampshade';

			}
		};

	},

	showRestartUndoGroup(enable) {

		if (enable) {

			$(this.ui.restartUndoGroup).addClass('active');

		} else {

			$(this.ui.restartUndoGroup).removeClass('active');

		}

	},

	cancelUpdateClick() {

		$(qtee).trigger('closeProdPanelContainer');

	},
	updateProductClick() {

		let diff;
		let collection;
		const that = this;
		const xhrsDel = [];
		const xhrsUp = [];
		// loader
		const stopLoader = this.$events.triggerHandler('startLoader', 0);

		qtee.customDesign.canvas.history = [];
		this.updateHistoryBtns();

		// let's flush all delayed saves before we stop emulate ajax calls
		for (type in qtee.customDesign.settings.names) {

			collection = qtee.customDesign.settings.names[type].collection;
			that.model.elements[collection].forEach((m) => {

				m.delayedSave.now();

			});

		}

		Backbone.customDesign.stopEmulateAjax();

		// update all elements
		for (type in qtee.customDesign.settings.names) {

			collection = qtee.customDesign.settings.names[type].collection;

			// find and destroy models that no more exist
			diff = this.initModel.elements[collection].filter((m) => !that.model.elements[collection].get(m.id));
			diff.forEach((m) => {

				xhrsDel.push(m.destroy());

			});

		}

		// since we have limits on elements we must wait for all 'delete' operations first and then add new
		jQuery.when(...xhrsDel).then(() => {

			for (type in qtee.customDesign.settings.names) {

				collection = qtee.customDesign.settings.names[type].collection;
				// create/update models on backend that still exist on front-end
				that.model.elements[collection].forEach((m) => {

					m.isFakeId() && m.clearId();
					xhrsUp.push(m.save());

				});

			}

		});

		// let's wait for all 'delete' first and then wait for all 'updates'
		jQuery.when(...xhrsDel).then(
			() => {

				jQuery.when(...xhrsUp).then(
					() => {

						// update model itself if sku was changed
						if (that.model.get('IsSkuChanged')) {

							that.model.save().then(() => {

								// TODO: replace with functionality to pull new images/data from server for cart
								window.location.reload();

							});

						} else {

							// TODO: replace with functionality to pull new images/data from server for cart
							window.location.reload();

						}

					},
					() => {
						// TODO: error handler for create/update errors
					}
				);

			},
			() => {
				// TODO: error handler for delete errors
			}
		);

	},

	closeEmptySceneMessageClick(e) {

		e.preventDefault();
		this.ui.emptySceneMessage.removeClass('on');

	},

	normalizeQty(e) {

		if (parseInt($(this.ui.qtyInput).val()) <= 0 || $(this.ui.qtyInput).val().trim() == '') {

			$(this.ui.qtyInput).val('1');

		}

	},

	normalizeQtyInput(e) {

		// allow only numbers
		if (e.which > 31 && (e.which < 48 || e.which > 57)) {

			return false;

		}

		return true;

	},

	previewClick(e, showWishlist, qty) {

		const that = this;

		// reshow restart / undo
		this.showRestartUndoGroup(true);
		qtee.customDesign.canvas.selectElement(-1);

		this.$events.triggerHandler('showDefaultSection');

		const runPreview = function () {

			// define preview model here in case user is cloning, we need to refresh model from the updated token
			that.previewModel = new qtee.customDesign.Preview({ Token: that.model.get('Token') });

			// fetch latest image
			that.previewModel.fetch({
				success: function success() {

					that.showChildView(
						'previewModalRegion',
						new qtee.customDesign.PreviewView({
							model: that.model,
							prodModel: that.prodModel,
							previewModel: that.previewModel,
							showCart: !showWishlist,
							qty
						})
					);

					// 'hasAddToCart' flag should be set to '0' for Add to Wishlist
					const previewModalGroup = document.querySelector('#previewModal .group');
					if (showWishlist && previewModalGroup && previewModalGroup.dataset) {

						previewModalGroup.dataset.hasAddToCart = 0;

					}

					$('body').lpModal({
						lpModalClass: 'largeClose',
						width: 940,
						height: 590,
						onInit: true,
						content: $(that.regions.previewModalRegion)
					});

				}
			});

		};

		const stopLoader = this.$events.triggerHandler('startLoader');
		const checkPreview = function checkPreview() {

			setTimeout(() => {

				if ($.active > 0) {

					checkPreview();

				} else {

					stopLoader();
					runPreview();

				}

			}, 2000);

		};

		checkPreview();

	},

	addToWishListClick(e) {

		e.preventDefault();
		this.normalizeQty();

		if (this.isSceneEmpty()) {

			this.ui.emptySceneMessage.addClass('on').addClass('wl').removeClass('top');

		} else {

			this.previewClick(e, true, parseInt($(this.ui.qtyInput).val()));

		}

	},

	addToCartClick(e) {

		e.preventDefault();

		this.normalizeQty();

		if (this.isSceneEmpty()) {

			this.ui.emptySceneMessage.addClass('on').removeClass('wl');

			if ($(e.currentTarget).hasClass('addToCartTop')) {

				this.ui.emptySceneMessage.addClass('top');

			} else {

				this.ui.emptySceneMessage.removeClass('top');

			}

		} else {

			this.previewClick(e, false, parseInt($(this.ui.qtyInput).val()));

		}

	},

	textFontClick() {

		const el = qtee.customDesign.canvas.getSelected();
		const model = this.model.elements.text.get({ cid: el.element.cid });

		if (model) {

			this.showTabSection(this.regions.fontTextElementRegion);
			this.showChildView(
				'fontTextElementRegion',
				new qtee.customDesign.FontTextView({
					model
				})
			);

		}

	},

	saveToFavorites(alt) {

		const that = this;
		const width = alt ? 330 : 400;
		const content = alt ? 'restartPrompt' : 'saveToFavorites';
		const sku = this.model.get('ShortSku');

		function syncFavoritesCount() {

			return $.ajax({
				url: '/api/favoriteitemscount',
				cache: false
			});

		}

		function done() {

			if (alt) {

				$('body').lpModalClose();

				if (that.model.isPillow()) {

					window.location.href = `${qtee.customDesign.settings.path}?restart=true`;

				} else {

					window.location.href = `${qtee.customDesign.settings.path}?sku=${sku}&restart=true`;

				}

			} else {

				$('.customDesignModal').addClass('saved');
				$(that.ui.saveBtn).removeClass('on').addClass('disabled');

				syncFavoritesCount().done((count) => {

					$(qtee).trigger('updateFavorites', { count });
					setTimeout(() => {

						$('body').lpModalClose();

					}, 2000);

				});

			}

		}

		function fail() {
			// TODO: error handler
		}

		$('body').lpModal({
			onInit: true,
			width,
			height: 180,
			openEvt() {

				$('.customDesignModal .cancelFavorites').on('click', (e) => {

					e.preventDefault();

					$('body').lpModalClose();

					if (that.model.isPillow()) {

						window.location.href = `${qtee.customDesign.settings.path}?restart=true`;

					} else {

						window.location.href = `${qtee.customDesign.settings.path}?sku=${sku}&restart=true`;

					}

				});

				$('.customDesignModal .saveFavorites').on('click', (e) => {

					e.preventDefault();

					if (Backbone.customDesign.isEmulateOn()) {

						Backbone.customDesign.stopEmulateAjax();
						const model = that.model.clone();
						model.save(
							{},
							{
								cloneBySprites: true,
								success: (r) => {

									qtee.customDesign.utils.addToWishlist(
										model.get('ShortSku'),
										1,
										model.get('Token'),
										'f5f5f5',
										true
									);

									setTimeout(() => {

										done();

									}, 1000);

								},
								error: (r) => {
									// TODO: error handler
								}
							}
						);
						Backbone.customDesign.startEmulateAjax();

					} else {

						qtee.customDesign.utils.addToWishlist(
							that.model.get('ShortSku'),
							1,
							that.model.get('Token'),
							'f5f5f5',
							true
						);

						setTimeout(() => {

							done();

						}, 1000);

					}

				});

			},
			closeEvt() {

				$('.customDesignModal .saveFavorites').off();
				$('.customDesignModal .cancelFavorites').off();

			},
			content: $(`#${content}`)
		});

	},

	textEditClick() {

		const model = this.model.elements.text.get({ cid: qtee.customDesign.canvas.getSelected().element.cid });
		if (model) {

			model.attributes.AreaWidth = this.model.area.Width;
			model.attributes.AreaHeight = this.model.area.Height;

			this.showTabSection(this.regions.editTextElementRegion);
			this.showChildView(
				'editTextElementRegion',
				new qtee.customDesign.EditTextView({
					model,
					textCollection: this.model.elements[qtee.customDesign.settings.names.text.collection]
				})
			);

		}

	},

	newTextElementClick(attrs) {

		const that = this;
		const clonedText = attrs && attrs.clonedText;
		let newTextView;

		qtee.customDesign.canvas.selectElement(-1);

		if (!clonedText) {

			const scrollTo = $(window).height() > 550
				? $('#customDesignCanvas').offset().top
				: $('#customDesignCanvas').offset().top * 1.5;

			$('html,body').animate(
				{
					scrollTop: scrollTo
				},
				'slow'
			);

		}

		// hide restart and undo group at bottom on maininterface
		this.disableAllSections();
		this.showTabSection(this.regions.newTextElementRegion);

		if (
			this.model.elements[qtee.customDesign.settings.names.text.collection].length
			>= qtee.customDesign.settings.limits.text
		) {

			this.showTextLimitModal();

		} else {

			const model = new qtee.customDesign.ElementModel(
				{
					AreaHeight: this.model.area.Height,
					AreaWidth: this.model.area.Width,
					OriginX: (attrs && attrs.x) || that.model.area.Width / 2,
					OriginY: (attrs && attrs.y) || that.model.area.Height / 2,
					Text: clonedText || '',
					FontSize: attrs && attrs.fontSize ? attrs.fontSize : qtee.customDesign.settings.newEl.text.fontSize,
					RotationalDegree:
						attrs && attrs.rotation ? attrs.rotation : qtee.customDesign.settings.newEl.text.rotation,
					FontName: qtee.customDesign.settings.newEl.text.fontFamily,
					Red: qtee.customDesign.settings.newEl.text.fill.r,
					Green: qtee.customDesign.settings.newEl.text.fill.g,
					Blue: qtee.customDesign.settings.newEl.text.fill.b,
					IsBold: qtee.customDesign.settings.newEl.text.fontBold,
					IsItalic: qtee.customDesign.settings.newEl.text.fontItalic,
					ZOrder: qtee.customDesign.canvas.getMaxZIndex() + 1
				},
				{ type: 'text' }
			);
			this.showChildView(
				'newTextElementRegion',
				new qtee.customDesign.NewTextView({
					model,
					textCollection: this.model.elements[qtee.customDesign.settings.names.text.collection],
					update: attrs && attrs.update
				})
			);

			newTextView = this.newTextElementRegion.currentView;
			$(newTextView.ui.newTextVal).prop('disabled', false);

		}

	},

	newDesignElement(attrs) {

		const that = this;
		const stopLoader = this.$events.triggerHandler('startLoader');

		this.model.elements.pattern.create(
			{
				OriginX: (attrs && attrs.x) || that.model.area.Width / 2,
				OriginY: (attrs && attrs.y) || that.model.area.Height / 2,
				PatternId: attrs.patternId,
				Scale: attrs && attrs.scale ? attrs.scale : qtee.customDesign.settings.newEl.design.scale,
				Width: that.isPillow
					? qtee.customDesign.settings.newEl.design.width
					: qtee.customDesign.settings.newEl.designLampshade.width,
				Height: that.isPillow
					? qtee.customDesign.settings.newEl.design.height
					: qtee.customDesign.settings.newEl.designLampshade.height,
				RotationalDegree:
					attrs && attrs.rotation ? attrs.rotation : qtee.customDesign.settings.newEl.design.rotation,
				PatternImageUrl: attrs.patternImageUrl,
				ZOrder: qtee.customDesign.canvas.getMaxZIndex() + 1
			},
			{
				wait: true,
				success: (r) => {

					this.statusProgress();
					qtee.customDesign.canvas.add(r).then(
						(el) => {

							this.operationSuccess(`${el.type} was added to canvas`);

						},
						(reason) => {

							this.operationError(reason);

						}
					);
					stopLoader();
					this.addToHistory([r]);

				},
				error: (r) => {

					stopLoader();
					this.operationError(r);

				}
			}
		);

	},

	newImageElement(attrs) {

		const that = this;
		const stopLoader = this.$events.triggerHandler('startLoader');
		const ratio = attrs
			&& Math.min(
				qtee.customDesign.settings.newEl.image.height / attrs.height,
				qtee.customDesign.settings.newEl.image.width / attrs.width
			);

		this.model.elements.image.create(
			{
				OriginX: (attrs && attrs.x) || that.model.area.Width / 2,
				OriginY: (attrs && attrs.y) || that.model.area.Height / 2,
				Scale: attrs && attrs.scale ? attrs.scale : qtee.customDesign.settings.newEl.image.scale * ratio,
				Height: attrs && attrs.height,
				Width: attrs && attrs.width,
				OriginalHeight: attrs && attrs.height,
				OriginalWidth: attrs && attrs.width,
				RotationalDegree:
					attrs && attrs.rotation ? attrs.rotation : qtee.customDesign.settings.newEl.image.rotation,
				ImageUrl: attrs && attrs.imgSrc,
				ZOrder: qtee.customDesign.canvas.getMaxZIndex() + 1
			},
			{
				wait: true,
				success: (r) => {

					this.statusProgress();
					qtee.customDesign.canvas.add(r).then(
						(el) => {

							this.operationSuccess(`${el.type} was added to canvas`);

						},
						(reason) => {

							this.operationError(reason);

						}
					);
					stopLoader();
					this.addToHistory([r]);

				},
				error: (r) => {

					stopLoader();
					this.operationError(r);

				}
			}
		);

	},

	/** Change sku of customized product */
	changeSku(sku) {

		const that = this;
		// show loader until stopLoader is invoked
		const stopLoader = this.$events.triggerHandler('startLoader');

		this.statusProgress();
		this.model.save(
			{ ShortSku: sku },
			{
				success() {

					// show loader for scene rendring until stopLoader is invoked
					const stopLoader = that.$events.triggerHandler('startLoader');

					that.renderScene().then(stopLoader);

					that.operationSuccess(`sku was changed to ${sku}`);

				},
				error(r) {

					that.operationError(r);

				},
				complete() {

					stopLoader();

				}
			}
		);

	},

	prodSkuChangeClick() {

		this.changeSku($(this.ui.prodSku).val().trim());

	},

	/** Get new scene */
	sceneGetClick() {

		const that = this;
		qtee.customDesign.router.navigate(`load/${$(this.ui.sceneId).val()}`);

		this.model
			.set({
				Token: $(this.ui.sceneId).val().trim()
			})
			.fetch({
				success() {

					that.prodModel.set({ ShortSku: that.model.get('ShortSku') }).fetch({
						success() {

							that.render();

						},
						error(r) {

							that.operationError(r);

						}
					});

				},
				error(r) {

					that.operationError(r);

				}
			});

	},

	/**
	 * Update current status
	 * @param {String} msg
	 * @param {Integer} code
	 */
	updateStatus(msg, code) {

		return;
		const $status = $(this.ui.status).html(msg);

		if (code == 0) {

			$status.removeClass().addClass('fail');

		} else if (code == 1) {

			$status.removeClass().addClass('success');

		} else {

			throw `Unsupported code: ${code}`;

		}

	},

	/**
	 * Add to history
	 * @property {Array of Backbone.Model} models
	 */
	addToHistory(models) {

		const restore = [];
		models.forEach((model) => {

			const attrs = {
				operation: model.lastOperation,
				type: model.type,
				isBackground: model.get('IsBackground'),
				sid: model.id,
				json: _.clone(model.attributes)
			};

			if (model.lastOperation == 'delete') {

				const length = restore.push(attrs);

				delete restore[length - 1].json.Token;
				delete restore[length - 1].json.VersionNumber;

				if (model.get('IsBackground')) {

					if (qtee.customDesign.currentBg) {

						qtee.customDesign.prevBg.push(_.clone(qtee.customDesign.currentBg));

					}

					qtee.customDesign.currentBg = {
						operation: model.lastOperation,
						type: model.type,
						isBackground: model.get('IsBackground'),
						sid: null,
						json: {}
					};

				}

			} else {

				restore.push({
					operation: model.lastOperation,
					type: model.type,
					isBackground: model.get('IsBackground'),
					sid: model.id,
					json: _.clone(model._savedPreviousAttributes)
				});

				if (model.get('IsBackground')) {

					if (qtee.customDesign.currentBg) {

						qtee.customDesign.prevBg.push(_.clone(qtee.customDesign.currentBg));

					}
					qtee.customDesign.currentBg = _.clone(attrs);

				}

			}

		});

		qtee.customDesign.canvas.history.push(restore);

		if (qtee.customDesign.canvas.history.length > 10) {

			qtee.customDesign.canvas.history.shift();

		}

		this.updateHistoryBtns();

	},

	/**
	 * Restore from history
	 */
	undoHistory() {

		const that = this;
		const restore = qtee.customDesign.canvas.history.pop();
		const xhrs = [];
		const stopLoader = this.$events.triggerHandler('startLoader', 0);
		const rerenderScene = function () {

			that.renderScene(true).then(() => {

				// get last restored element by sid (token)
				const el = qtee.customDesign.canvas.getElementBySid(restore[restore.length - 1].sid);

				if (el) {

					qtee.customDesign.canvas.selectElement(el.element.id);

					that.updateHistoryBtns();

				} else {

					// close tab's section and update element's contols if don't have last restored element
					that.showTabSection(false);

					// hide restart and undo group at bottom on maininterface
					that.showRestartUndoGroup(true);
					that.updateElementsControls();
					that.updateHistoryBtns();

				}
				that.renderSuccess();
				stopLoader();

			});

		};

		const undoPrePattern = function (res) {

			if (res && res.isBackground && qtee.customDesign.prevBg.length) {

				const thisBg = qtee.customDesign.prevBg.pop();
				qtee.customDesign.currentBg = thisBg;
				if (thisBg.sid) {

					delete thisBg.json.Token;
					const restoreBg = _.clone(thisBg);
					const deffered = $.Deferred();
					xhrs.push(deffered);
					that.model.elements[qtee.customDesign.settings.names[thisBg.type].collection].create(thisBg.json, {
						wait: true,
						success(model) {

							// we need to update history since we create new element instead of deleted
							qtee.customDesign.canvas.history.forEach((r) => {

								r.forEach((el) => {

									if (el.sid == thisBg.sid) {

										el.sid = model.id;

									}

								});

							});
							deffered.resolve();
							rerenderScene();

						},
						error() {

							deffered.reject();

						}
					});

				}

			} else {

				qtee.customDesign.currentBg = {
					operation: 'create',
					type: 'pattern',
					isBackground: true,
					sid: null,
					json: {}
				};

			}

		};

		if (!restore) {

			return false;

		}
		const { history } = qtee.customDesign.canvas;
		this.updateHistoryBtns();

		// collect all model changes in this restore
		restore.forEach((res) => {

			if (res.operation == 'update') {

				xhrs.push(
					that.model.elements[qtee.customDesign.settings.names[res.type].collection]
						.findWhere({ Token: res.sid })
						.save(res.json)
				);

			} else if (res.operation == 'create') {

				const isPatternAvailble = that.model.elements[
					qtee.customDesign.settings.names[res.type].collection
				].findWhere({ Token: res.sid });
				if (isPatternAvailble) {

					xhrs.push(
						that.model.elements[qtee.customDesign.settings.names[res.type].collection]
							.findWhere({ Token: res.sid })
							.destroy({
								wait: true,
								success() {

									undoPrePattern(res);

								}
							})
					);

				} else {

					undoPrePattern(res);

				}

			} else if (res.operation == 'delete') {

				const deffered = $.Deferred();
				xhrs.push(deffered);

				if (res.isBackground && qtee.customDesign.prevBg.length) {

					qtee.customDesign.currentBg = qtee.customDesign.prevBg.pop();

				}

				that.model.elements[qtee.customDesign.settings.names[res.type].collection].create(res.json, {
					wait: true,
					success(model) {

						// we need to update history since we create new element instead of deleted
						qtee.customDesign.canvas.history.forEach((r) => {

							r.forEach((el) => {

								if (el.sid == res.sid) {

									el.sid = model.id;

								}

							});

						});
						deffered.resolve();

					},
					error() {

						deffered.reject();

					}
				});

			} else {

				stopLoader();
				throw `Unsupported operation: ${res.operation}`;

			}

		});

		this.statusProgress();
		// when all model changes are done then rerender scene and select last restored element if one exist
		$.when(...xhrs).then(
			() => {

				rerenderScene();

			},
			(reason) => {

				stopLoader();
				// TODO: actual error handler when we was not able to restore at least one element
				throw reason;

			}
		);

	},

	/**
	 * Set status to 'processing'
	 * @param {String} msg
	 */
	statusProgress(msg) {

		if (typeof msg === 'string') {

			this.updateStatus(msg, 1);

		} else {

			this.updateStatus('Processing...', 1);

		}

	},

	/**
	 * Common error handler for canvas operations
	 * @param {String} reason
	 */
	renderError(reason) {

		this.updateStatus(`Fail: ${reason}`, 0);

	},

	/** Common success handler for canvas operations */
	renderSuccess() {

		// update status
		this.updateStatus('Ok', 1);

	},

	/**
	 * Common success handler for Backbone's save, create, delete
	 * @param {String} msg
	 */
	operationSuccess(msg) {

		if (msg) {

			msg = ` - ${msg}`;

		} else {

			msg = '';

		}
		// update status
		this.updateStatus(`Ok${msg}`, 1);

	},

	showLimitModal(max, type, todo) {

		this.ui.limitReachedModal.find('.max').html(max);
		this.ui.limitReachedModal.find('.type').html(type);
		this.ui.limitReachedModal.find('.todo').html(todo);

		$('body').lpModal({
			lpModalClass: 'largeClose',
			width: 500,
			height: 170,
			onInit: true,
			content: this.ui.limitReachedModal,
			openEvt() {

				$('.closeModal').one('click', (e) => {

					e.preventDefault();
					$('body').lpModalClose();

				});

			}
		});

	},

	showImageLimitModal() {

		this.showLimitModal(qtee.customDesign.settings.limits.image, 'images', 'add and remove photos and graphics');

	},
	showDesignLimitModal() {

		this.showLimitModal(
			qtee.customDesign.settings.limits.design,
			'graphic elements (which includes graphics, frames and backgrounds)',
			'add and remove elements'
		);

	},
	showTextLimitModal() {

		this.showLimitModal(qtee.customDesign.settings.limits.text, 'text elements', 'edit and remove text');

	},

	/**
	 * Common error handler for Backbone's save, create, delete
	 * @param {Backbone.Model}
	 */
	operationError(model) {

		const that = this;

		if (model.operationResult) {

			// if it was limit for image
			if (model.operationResult.ResultCode === 3) {

				// if modal is not closed
				if ($('#lpModal').length) {

					this.$events.one('closed.lpModal', () => {

						that.showImageLimitModal();

					});

				} else {

					this.showImageLimitModal();

				}

			}

			// if it was limit for text
			if (model.operationResult.ResultCode === 7) {

				this.showTextLimitModal();

			}

			// if it was limit for text
			if (model.operationResult.ResultCode === 6) {

				this.showDesignLimitModal();

			}

			this.updateStatus(`Fail: ${model.operationResult.ErrorMessage}`, 0);

		} else {

			this.updateStatus('Fail: server error', 0);

		}

	},

	textColorClick() {

		// TextColorsView
		this.showChildView(
			'colorTextRegion',
			new qtee.customDesign.TextColorsView({ model: qtee.customDesign.availableColors })
		);
		this.showTabSection(this.regions.colorTextRegion);

	},

	addNewDesignEnter(e) {

		if (e.key === 'Enter') {

			this.addNewDesignClick();
			return false;

		}
		return true;

	},

	newTextElementEnter(e) {

		if (e.key === 'Enter') {

			this.newTextElementClick();
			return false;

		}
		return true;

	},

	addImageEnter(e) {

		if (e.key === 'Enter') {

			this.addImageClick();
			return false;

		}
		return true;

	},

	addNewBackgroundEnter(e) {

		if (e.key === 'Enter') {

			this.addNewBackgroundClick();
			return false;

		}
		return true;

	},

	textDoneKeyPress(e) {

		if (e.keyCode === 13) {

			this.sectionDoneClick();

		}

	},

	addNewDesignClick() {

		if (
			this.model.elements[qtee.customDesign.settings.names.pattern.collection].length
			>= qtee.customDesign.settings.limits.design
		) {

			this.showDesignLimitModal();

		}

		// hide restart and undo group at bottom on maininterface
		this.showRestartUndoGroup(false);
		this.disableAllSections();

		// NewDesignView
		this.showChildView(
			'newDesignElementRegion',
			new qtee.customDesign.NewDesignView({
				model: qtee.customDesign.availablePatterns,
				customModel: this.model,
				isPillow: this.model.isPillow()
			})
		);
		this.showTabSection(this.regions.newDesignElementRegion);
		$('#customDesignBody').addClass('menuOpen menuGraphics');

	},

	addNewBackgroundClick() {

		// we don't have to show the limit modal if a background exists in the scene, since we are only replacing it
		const hasBackground = _.findIndex(
			this.model.elements.pattern.models,
			(el) => el.attributes && el.attributes.IsBackground == true
		) >= 0;

		if (
			this.model.elements[qtee.customDesign.settings.names.pattern.collection].length
			>= qtee.customDesign.settings.limits.design
			&& !hasBackground
		) {

			this.showDesignLimitModal();

		}

		// hide restart and undo group at bottom on maininterface
		this.showRestartUndoGroup(false);
		this.disableAllSections();

		// NewBackgroundView
		this.showChildView(
			'newBackgroundElementRegion',
			new qtee.customDesign.NewBackgroundView({
				model: qtee.customDesign.availablePatterns,
				customModel: this.model,
				hasBackground,
				isPillow: this.model.isPillow()
			})
		);
		this.showTabSection(this.regions.newBackgroundElementRegion);
		$('#customDesignBody').addClass('menuOpen menuGraphics');

	},

	/** Add new image */
	addImageClick() {

		const that = this;

		// show default section
		this.disableAllSections();
		// hide restart and undo group at bottom on maininterface
		this.showRestartUndoGroup(true);

		if (
			qtee.customDesign.canvas.getAllElementsByType('uploadedimage').length
			>= qtee.customDesign.settings.limits.image
		) {

			this.showImageLimitModal();

		} else {

			window.qtee.customDesign.stopLoader = this.$events.triggerHandler('startLoader');
			$(this.regions.newImageElementRegion).html(
				`<iframe width="100%" height="100%" src="${qtee.customDesign.settings.path}/upload" scrolling="auto" horizontalscrolling="no" verticalscrolling="no" frameborder="0"></iframe><div class="back imageBack">Close <span></span></div>`
			);
			this.showTabSection(this.regions.newImageElementRegion);
			$('#customDesignBody').addClass('menuOpen menuImages');

			$('.imageBack')
				.off()
				.on('click', () => {

					$(that.ui.newImageSection).hide();
					$('.restartUndoGroup').addClass('active');
					that.sectionDoneClick();

				});

		}

	},

	/**
	 * We use this function to show sections that doesn't have a tab since we have more sections than tabs (we have sections for element's controls)
	 * @param {string|false} sectionId
	 */
	showTabSection(sectionId) {

		const $section = $(sectionId);
		let $tab;

		this.disableAllSections();

		if (sectionId !== -1 && !$section.is(':visible')) {

			// hide all sections and tabs
			if ($section.length) {

				// show chosen section
				$section.show();
				this.bindToolTips();

			}

		}

	},

	/** Update history btns */
	updateHistoryBtns() {

		if (qtee.customDesign.canvas.history.length > 0) {

			$(this.ui.undoBtn).removeClass('disabled');
			$('#editTextElement .undo').removeClass('disabled');
			$('#editImageElement .undo').removeClass('disabled');
			$('#editDesignElement .undo').removeClass('disabled');
			$('#restartUndoGroup .undo').removeClass('disabled');

		} else {

			$(this.ui.undoBtn).addClass('disabled');
			$('#editTextElement .undo').addClass('disabled');
			$('#editImageElement .undo').addClass('disabled');
			$('#editDesignElement .undo').addClass('disabled');
			$('#restartUndoGroup .undo').addClass('disabled');

		}

	},

	/**
	 * Update common elements controls ( like remove, move back/forward)
	 * @param {element|bool}  element
	 */
	updateElementsControls(element, clone) {

		const checkDuplicateBtn = () => {

			if (element && element._type === 'pattern') {

				let limit = qtee.customDesign.settings.limits.design;

				limit = clone ? --limit : limit;

				if (qtee.customDesign.canvas.getAllElementsByType('pattern').length < limit) {

					$(this.ui.duplicateBtn).removeClass('disabled');

				}

			} else if (element && element._type === 'uploadedimage') {

				let limit = qtee.customDesign.settings.limits.image;

				limit = clone ? --limit : limit;

				if (qtee.customDesign.canvas.getAllElementsByType('uploadedimage').length < limit) {

					$(this.ui.duplicateBtn).removeClass('disabled');

				}

			}

		};

		// always disable duplicate button first
		$(this.ui.duplicateBtn).addClass('disabled');

		if (element) {

			$(this.ui.commonControls).removeClass('disabled');

			if (qtee.customDesign.canvas.history <= 1) {

				$(this.ui.commonControls).addClass('disabled');

			}

			if (qtee.customDesign.canvas.isElementOnBack(element)) {

				$(this.ui.backBtn).addClass('disabled');

			}

			if (qtee.customDesign.canvas.isElementOnFront(element)) {

				$(this.ui.forwardBtn).addClass('disabled');

			}

			checkDuplicateBtn();

		} else if (clone) {

			$(this.ui.commonControls).removeClass('disabled');
			$(this.ui.forwardBtn).addClass('disabled');

			checkDuplicateBtn();

		} else {

			$(this.ui.commonControls).addClass('disabled');

		}

	},

	isSceneEmpty() {

		for (const type in qtee.customDesign.settings.names) {

			if (
				this.model.elements[qtee.customDesign.settings.names[type].collection]
				&& this.model.elements[qtee.customDesign.settings.names[type].collection].length > 0
			) {

				return false;

			}

		}

		return true;

	},

	/** Show social buttons if at least one element exists in customized product and hide otherwise */
	updateCommonUI() {

		this.updateHistoryBtns();

		if (this.isSceneEmpty()) {

			$(this.ui.shareBtn).addClass('disabled');
			$(this.ui.restartBtn).addClass('disabled');
			$(this.ui.preview).addClass('disabled');
			this.ui.updateProduct.addClass('disabled');
			$(this.ui.shareBtn).removeClass('socialMediaContainer');

		} else {

			$(this.ui.shareBtn).addClass('socialMediaContainer');
			$(this.ui.shareBtn).removeClass('disabled');
			$(this.ui.restartBtn).removeClass('disabled');
			$(this.ui.preview).removeClass('disabled');
			this.ui.updateProduct.removeClass('disabled');

		}

	},

	bindToolTips() {

		if (!$(this.ui.forwardBtn).hasClass('disabled')) {

			this.ui.forwardBtn.lpTooltip({
				tooltip: $('.forwardToolTip'),
				useParentOffset: true,
				offsetX: 0,
				offsetY: -58,
				arrowColor: '#EEECED'
			});

		}

		if (!$(this.ui.backBtn).hasClass('disabled')) {

			this.ui.backBtn.lpTooltip({
				tooltip: $('.backwardToolTip'),
				useParentOffset: true,
				offsetX: 0,
				offsetY: -58,
				arrowColor: '#EEECED'
			});

		}

	},

	centerClick(e, bypass) {

		const el = qtee.customDesign.canvas.getSelected().element;
		el.setX(this.model.area.Width / 2)
			.setY(this.model.area.Height / 2)
			.apply();

		if (!bypass) {

			$(qtee.customDesign).trigger('transformed.elements.canvas', el);

		}

	},
	straightClick(e, bypass, forceZero) {

		const el = qtee.customDesign.canvas.getSelected().element;
		let angle = 0;

		if (!forceZero) {

			if (el.getR() <= 45 || el.getR() > 315) {

				angle = 0;

			} else if (el.getR() <= 135) {

				angle = 90;

			} else if (el.getR() <= 225) {

				angle = 180;

			} else if (el.getR() <= 315) {

				angle = 270;

			}

		}

		el.setR(angle).apply();

		if (!bypass) {

			$(qtee.customDesign).trigger('transformed.elements.canvas', el);

		}

	},
	fillClick(e) {

		this.centerClick(e, true);
		this.straightClick(e, true);

		const el = qtee.customDesign.canvas.getSelected().element;
		const { width } = el._origin;
		const { height } = el._origin;
		const canvasW = this.model.area.Width;
		const canvasH = this.model.area.Height;
		const wRatio = canvasW / width;
		const hRatio = canvasH / height;
		const oScale = el._origin.scale;

		const fScale = wRatio > hRatio ? wRatio : hRatio;

		el.setS(fScale).apply();
		$(qtee.customDesign).trigger('transformed.elements.canvas', el);
		qtee.customDesign.canvas.selectElement(el.id);

	},
	forwardClick(e) {

		qtee.customDesign.canvas.moveUpSelected();

	},

	backClick(e) {

		qtee.customDesign.canvas.moveDownSelected();

	},

	duplicateClick(e) {

		const el = qtee.customDesign.canvas.getSelected();
		const startX = this.model.area.Width / 2;
		const startY = this.model.area.Height / 2;
		let { rotate } = el.element.rel.freeTransform.attrs;
		const start = qtee.customDesign.utils.calcDuplicatePosition(el.element._type, startX, startY, rotate);

		rotate = rotate < 0 ? 360 + rotate : rotate;

		// must disable duplicate button to prevent rapid clicking, until the model is updated from server
		$(this.ui.duplicateBtn).addClass('disabled');

		if (el.element._type === 'pattern') {

			const url = el.element.rel.attrs.src.split('&wid=')[0];
			const urlSplit = url.split(/[/_]/);

			this.newDesignElement({
				patternImageUrl: url,
				patternId: urlSplit[urlSplit.length - 3],
				x: start.x,
				y: start.y,
				rotation: rotate,
				scale: el.element.rel.freeTransform.attrs.scale.x
			});

		} else if (el.element._type === 'uploadedimage') {

			this.newImageElement({
				imgSrc: el.element.rel.attrs.src.split('?qlt=')[0],
				width: el.element.rel.attrs.width,
				height: el.element.rel.attrs.height,
				x: start.x,
				y: start.y,
				rotation: rotate,
				scale: el.element.rel.freeTransform.attrs.scale.x
			});

		}

	},

	/**
	 * Update element
	 * @param {element} el
	 */
	updateElement(element) {

		const that = this;
		const collection = this.model.elements[qtee.customDesign.settings.names[element.type].collection];
		if (!collection) {

			throw `There are no elements with type: ${element.type}`;

		}
		const model = collection.get({ cid: element.cid });
		// since model and svg element are both independently asynchronous
		// it possible to have svg element but don't have model for that element and vice versa

		if (model) {

			this.statusProgress();
			return {
				xhr: model.save(element.saveToModel(), {
					success(r) {

						that.operationSuccess(r);

					},
					error(r) {

						that.operationError(r);

					}
				}),
				model
			};

		}

		return false;

	},

	/**
	 * Delete element
	 * @param {{element, index}} el
	 * @param {Boolean} skipHistory
	 */
	deleteElement(el, skipHistory, success) {

		const { history } = qtee.customDesign.canvas;

		if (el) {

			// Check if element has associated cid
			if (el.element.cid) {

				this.statusProgress();
				const that = this;
				const model = this.model.elements[qtee.customDesign.settings.names[el.element.type].collection].get({
					cid: el.element.cid
				});

				if (model) {

					qtee.customDesign.canvas.removeElementByIndex(el.index);
					model.destroy({
						success(r) {

							that.operationSuccess(`${r.type} was deleted`);
							if (!skipHistory) {

								that.addToHistory([r]);

							}

							success && success();

						},
						error(r) {

							that.operationError(r);

						}
					});

				} else {

					// model was previously deleted so we need just clear up svg element
					that.operationSuccess('canvas element was removed');
					qtee.customDesign.canvas.removeElementByIndex(el.index);

				}

			} else {

				qtee.customDesign.canvas.removeElementByIndex(el.index);

			}

		}

	},

	getSnapshot() {

		const that = this;

		return $.ajax({
			type: 'POST',
			url: `/api/customizedproducts/snapshot/${this.model.get('Token')}`
		});

	},

	pinterestClick(e) {

		const that = this;

		this.getSnapshot().done((data) => {

			const pinterestUrl = 'https://www.pinterest.com/pin/create/button?';
			const params = {
				url: that.getSceneUrl(data.Product.Token),
				media: data.Product.ImageUrl,
				description: `I designed this pillow at Lamps Plus! You can too! Visit ${that.getSceneUrl(
					data.Product.Token
				)}`
			};
			window.open(pinterestUrl + $.param(params), 'Pin it', 'height=400, width=767');

		});

	},

	facebookClick(e) {

		const that = this;

		this.getSnapshot().done((data) => {

			const facebookUrl = 'https://www.facebook.com/sharer/sharer.php?';
			const params = {
				u: that.getSceneCrawlerUrl(data.Product.Token)
			};
			window.open(facebookUrl + $.param(params), 'Facebook Share', 'height=350, width=500');

		});

	},

	googleClick(e) {

		const that = this;

		this.getSnapshot().done((data) => {

			const googleUrl = 'https://plus.google.com/share?';
			const params = {
				url: that.getSceneCrawlerUrl(data.Product.Token)
			};
			window.open(googleUrl + $.param(params), 'Google+ Share', 'height=350, width=500');

		});

	},

	houzzClick(e) {

		const that = this;

		this.getSnapshot().done((data) => {

			const houzzUrl = 'https://www.houzz.com/imageClipperUpload?';
			const params = {
				link: that.getSceneUrl(data.Product.Token),
				source: 'button',
				hzid: '33182',
				imageUrl: data.Product.ImageUrl,
				ref: that.getSceneUrl(data.Product.Token)
			};
			window.open(houzzUrl + $.param(params), 'Houzz Share', 'height=450, width=700');

		});

	},

	emailClick(event) {

		const request = dynamicImport(
			'desktop/customDesign-email',
			'../../../_client/pages/product/desktop/email'
		).then((module) => {

			const initEmailModal = module.default;
			return initEmailModal('', this.model.get('ShortSku'), this.model.get('Token'));

		});
		addClassDuringActivity(event.currentTarget, 'noPointerEvents', request);

	},
	sectionDoneClick() {

		qtee.customDesign.canvas.selectElement(-1);

		$('#customDesignBody').removeClass('menuOpen menuGraphics menuImages');

	},

	disableAllSections() {

		$('#customDesignBody').removeClass('menuOpen menuGraphics menuImages');

		$(this.ui.otherStylesSection).hide();
		$(this.ui.newTextElementSection).hide();
		$(this.ui.editTextElementSection).hide();
		$(this.ui.colorTextElementSection).hide();
		$(this.ui.fontTextElementSection).hide();
		$(this.ui.sizeTextSection).hide();
		$(this.ui.newDesignSection).hide();
		$(this.ui.imageSection).hide();
		$(this.ui.newImageSection).hide();
		$(this.ui.editDesignSection).hide();
		$(this.ui.editBackgroundSection).hide();
		$(this.ui.backgroundSection).hide();

	},

	deleteClick() {

		const el = qtee.customDesign.canvas.getSelected();
		this.deleteElement(el);

	},

	undoClick() {

		this.undoHistory();

	},

	restartClick() {

		this.saveToFavorites(true);

	},

	shareClick() {

		// this.ui.middleIconsWrapper.toggleClass('withSpacer');
		$(this.ui.socialButtons).toggle();

	},

	shareOn() {

		// this.ui.socialButtons.is(':hidden') && this.ui.middleIconsWrapper.toggleClass('withSpacer');
		$(this.ui.socialButtons).show();

	},

	shareOff() {

		// this.ui.socialButtons.is(':visible') && this.ui.middleIconsWrapper.toggleClass('withSpacer');
		$(this.ui.socialButtons).hide();

	},

	print(e) {

		$(this.ui.shareTooltip).hide(); // hide share tooltip
		$(this.ui.helpers).hide(); // hide help icons
		qtee.customDesign.canvas.selectElement(-1); // unselect all sprites
		window.print();

	},

	getSceneUrl(token) {

		return `${qtee.customDesign.settings.domain + qtee.customDesign.settings.path}#load/${token || this.model.get('Token')
			}`;

	},

	getSceneCrawlerUrl(token) {

		return `${qtee.customDesign.settings.domain + qtee.customDesign.settings.path}/crawler/${token || this.model.get('Token')
			}`;

	},

	openShippingModal(e) {

		e.preventDefault();
		dynamicImport('desktop/product-shipsInModal', '../../../_client/pages/product/desktop/shipsInModal').then(
			(module) => {

				const initShipsInModal = module.default;
				initShipsInModal(shippingTerms);

			}
		);

	}
});
